import { useGetDevicesQuery } from "../services/deviceApi";

/**
 * The organization's devices. Returns an empty fleet rather than an error when
 * the control plane has no relay configured, so the project form degrades to
 * the local-address path instead of breaking.
 */
export const useDeviceFleet = () => {
  const { data, isLoading, isError } = useGetDevicesQuery();

  return {
    devices: data?.devices ?? [],
    isLoading,
    isError,
  };
};
